import { useState,useMemo } from "react";
import { Form, Button, Col, Row, Table, Container, Modal, Card } from "react-bootstrap";
import api from '../../api/apiweb-receptoresfacturas.js';
import Rut from "rutjs";
import actividadEconomica from '../../constants/codigos_actividad_economica.json';
import { FaCog, FaRegTrashAlt, FaShuttleVan } from "react-icons/fa";
import ModalReceptorForm from "./ModalReceptorForm.jsx";
import regionesData from "../../constants/regiones_comunas.json";

function ReceptorFactura(props) {
  const initialState = {
    rut: "",
    razonSocial: "",
    direccion: "",
    comuna: "",
    ciudad: "",
    giro: "",
    telefono: "",
    email: "",
    acteco: "",

  };
  
  const [formData, setFormData] = useState(initialState);

  // const [ setRutReceptorError] = useState("");

  const [erroresReceptor, setErroresReceptor] = useState([]);
  const [mostrarModalErrores, setMostrarModalErrores] = useState(false);
  const [loading, setLoading] = useState(false);
  const [totalResultados, setTotalResultados] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loadingMensaje, setLoadingMensaje] = useState("");
  const [errorApi, setErrorApi] = useState(null);
  const [mostrarModalErrorApi, setMostrarModalErrorApi] = useState(false);

  const [rutBusquedaError, setRutBusquedaError] = useState("");
  const [busquedaRealizada, setBusquedaRealizada] = useState(false);
  const opcionesActividad = actividadEconomica.map((item) => ({
    value: item.codigo,
    label: `${item.codigo} - ${item.nombre}`,
  }));
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showModalAgregarReceptor, setShowModalAgregarReceptor] = useState(false);
  const handleCloseSuccessModal = () => setShowSuccessModal(false);
  const [showModalEditar, setShowModalEditar] = useState(false);
  const [showModalEliminar, setShowModalEliminar] = useState(false);
  const [showModalTransportes, setShowModalTransportes] = useState(false);
  const [receptorSeleccionado, setReceptorSeleccionado] = useState(null);
  const [messageSuccess, setMessageSuccess] = useState("");
  const [sucessTitle, setSucessTitle] = useState("");
  const [filtros, setFiltros] = useState({
    rut: "",
    razon_social: "",
    ciudad: "",
    comuna: ""
  });

  const [receptores, setReceptores] = useState([]);
  const [transportesReceptor, setTransportesReceptor] = useState([]);
  const [transporteAEliminar, setTransporteAEliminar] = useState([]);
  const [showModalEliminarTransporte, setShowModalEliminarTransporte] = useState(false);

  //agregar transporte
  const [showModalAgregarTransporte, setShowModalAgregarTransporte] = useState(false);
  const [nuevoTransporte, setNuevoTransporte] = useState({
    patente: "",
    vehicle_type: "",
  });
  const [patenteError, setPatenteError] = useState("");
  const [patenteValid, setPatenteValid] = useState(false);
  const [savingTransporte, setSavingTransporte] = useState(false);

  const regiones = regionesData.regiones; 

const groupedRegionOptions = useMemo(() => {
return regiones.map((r) => ({
label: r.region,
options: r.comunas.map((c) => ({
value: c,
label: c,
})),
}));
}, [regiones]);
// console.log (groupedRegionOptions)
  const handleFiltroChange = (campo, valor) => {
    setFiltros((prev) => ({ ...prev, [campo]: valor }));
  };

  const buscarReceptores = async (page = 1) => {

    // Validar RUT antes de enviar
    // if (filtros.rut && !new Rut(filtros.rut).validate()) {
    //   console.error("RUT inválido:", filtros.rut);
    //   return;
    // }

    // console.log("Buscando receptores con filtros:", filtros, "Página:", page);


    const sinDV = new Rut(filtros.rut).rut
    filtros.rutsv = sinDV;
    // return;
    setLoadingMensaje("Buscando receptores, por favor espere...");
    setLoading(true);

    try {
      const response = await api.getReceptores({
        ...filtros,
        page,
        limit: 20
      });

      const { body, totalPages, currentPage, total } = response.data;
      // console.log("Respuesta de la API:", response.data);

      // console.log("Receptores obtenidos:", body);
      setTotalResultados(total || 0);
      setReceptores(body);
      setTotalPages(totalPages || 1);
      setCurrentPage(currentPage || 1);
    } catch (error) {
      console.error("Error al buscar receptores:", error.response?.data?.msg || error.message);
      setErrorApi("Error al buscar receptores: " + error.response?.data?.msg || error.message);
      setMostrarModalErrorApi(true);
    } finally {
      setBusquedaRealizada(true);
      setLoading(false);
    }
  };

  const limpiarFiltros = () => {
    const filtrosLimpios = {
      rut: "",
      razonSocial: "",
      ciudad: "",
      comuna: ""
    };
    setFiltros(filtrosLimpios);
    // buscarReceptores(); // recarga sin filtros
  };


  const formatearTelefonoChileno = (input) => {
    //Si telefono es null o undefined, retornamos vacío
    if (input == null) return "";


    let numeros = input.replace(/\D/g, '');

    

    // Si no hay nada, no formateamos
    if (numeros === "" ) return "";


    // Quitar el 56 si viene
    if (numeros.startsWith("56")) {
      numeros = numeros.slice(2);
    }

    numeros = numeros.slice(0, 9);

    // Si ya está vacío después de quitar 56, no formateamos
    if (numeros === "") return "";

    if (numeros.startsWith("9")) {
      return `+56 9 ${numeros.slice(1, 5)} ${numeros.slice(5, 9)}`.trim();
    } else {
      return `+56 ${numeros.slice(0, 2)} ${numeros.slice(2, 9)}`.trim();
    }
  };



  const handleLimpiarFormulario = () => {
    setFormData((prev) => ({
      ...initialState,

    }));
    // setRutReceptorError("");
    setErroresReceptor([]);
    setMostrarModalErrores(false);
  };





  const generarJsonEnvio = () => {
    const jsonGenerado = {
      rut: new Rut(formData.rut).rut,
      razonsocial: formData.razonSocial,
      giro: formData.giro,
      direccion: formData.direccion,
      comuna: formData.comuna,
      acteco:
      formData.acteco && formData.acteco.toString().trim() !== ""
        ? formData.acteco
        : null,
      ciudad: formData.ciudad,
      telefono: formData.telefono.replace(/\D/g, ''), // Guardar solo números
      email: formData.email,
    }

    // console.log("jsonGenerado", JSON.stringify(jsonGenerado));

    return jsonGenerado;



  }

  const handleAgregarReceptor = async (e) => {
    e.preventDefault();


    // validarReceptor();
    if (!validarReceptor()) {
      // console.log("Errores de validación:", erroresReceptor);
      return;
    }
    setLoadingMensaje("Agregando receptor factura, por favor espere...");
    setLoading(true);



    const jsonenvio = generarJsonEnvio();

    // console.log("jsonenvio", jsonenvio);

    try {
      await api.addReceptor(jsonenvio);
      setLoading(false);
      setShowSuccessModal(true);
      setSucessTitle("Agregar Receptor");
      setMessageSuccess("Receptor agregado exitosamente.");
      setFormData(initialState); 
    } catch (error) {
      // console.error("Error al agregar receptor:", error.response.data.msg);
      setErrorApi("Error al agregar receptor: " + error.response.data.msg);
      setMostrarModalErrorApi(true);
      setLoading(false);
      return;

    }
    finally {
      setShowModalAgregarReceptor(false); // Cerrar modal después de agregar

    }


  };

  const handleEditarReceptor = async (e) => {
    e.preventDefault();
    // console.log("Editar receptor", formData);

    // validarReceptor();
    if (!validarReceptor()) {
      // console.log("Errores de validación:", erroresReceptor);
      return;
    }
    setLoadingMensaje("Editando receptor factura, por favor espere...");
    setLoading(true);

    const jsonenvio = generarJsonEnvio();

    // console.log("jsonenvio", jsonenvio);

    try {
      await api.updateReceptor(jsonenvio);
      setLoading(false);
      setShowSuccessModal(true);
      setSucessTitle("Editar Receptor");
      setMessageSuccess("Receptor actualizado exitosamente.");
      buscarReceptores(currentPage); // Recargar la lista de receptores
      setFormData(initialState); // Limpiar formulario después de agregar
    } catch (error) {
      console.error("Error al agregar receptor:", error);
      setErrorApi("Error al agregar receptor: " + error.message);
      setMostrarModalErrorApi(true);
      setLoading(false);
      return;

    }
    finally {
      setShowModalEditar(false); // Cerrar modal después de agregar

    }

  };



  const handleEditReceptor = (receptor) => {

    setFormData({
      rut: new Rut(receptor.rut + "", true).getNiceRut(),
      razonSocial: receptor.razon_social,
      direccion: receptor.direccion,
      comuna: receptor.comuna,
      ciudad: receptor.ciudad,
      giro: receptor.giro,
      acteco: receptor.acteco_codigo,
      telefono: formatearTelefonoChileno(receptor.telefono),
      email: receptor.email
    });
    setShowModalEditar(true);
  };


  const handleEliminarReceptor = async () => {

    console.log("Eliminar receptor", receptorSeleccionado);
    // return;
    setLoadingMensaje("Eliminando receptor factura, por favor espere...");
    if (!receptorSeleccionado) {
      console.error("No hay receptor seleccionado para eliminar.");
      return;
    }

    setLoading(true);
    try {
      await api.deleteReceptor(receptorSeleccionado.rut);

      setShowModalEliminar(false);
      setShowSuccessModal(true);
      setSucessTitle("Eliminar Receptor");
      setMessageSuccess("Receptor eliminado exitosamente.");
      // Recarga la tabla
      buscarReceptores(currentPage);
    } catch (error) {
      console.error("Error al eliminar receptor:", error);
      setErrorApi("No se pudo eliminar el receptor.");
      setMostrarModalErrorApi(true);
    }
    finally {
      setLoading(false);
      setReceptorSeleccionado(null); // Limpiar receptor seleccionado
    }
  };

  const validarReceptor = () => {
    const receptor = formData;
    const errores = [];

    // console.log("validarReceptor", receptor);

    const rutValido = new Rut(receptor.rut).validate();

    if (!rutValido) {
      errores.push("El RUT del receptor es inválido.");
      // setRutReceptorError("RUT inválido");
    } else {
      // setRutReceptorError("");
    }

    const camposObligatorios = [
      { campo: "razonSocial", etiqueta: "Razón Social" },
      { campo: "direccion", etiqueta: "Dirección" },
      { campo: "comuna", etiqueta: "Comuna" },
      { campo: "ciudad", etiqueta: "Ciudad" },
      // { campo: "acteco", etiqueta: "Código de Actividad Económica" },
      { campo: "giro", etiqueta: "Giro" },
    ];

    if (receptor.razonSocial.length > 100) errores.push("Razón Social no puede superar los 100 caracteres.");
    if (receptor.giro.length > 80) errores.push("Giro no puede superar los 80 caracteres.");
    // if (receptor.contacto.length > 80) errores.push("Contacto no puede superar los 80 caracteres.");
    if (receptor.direccion.length > 60) errores.push("Dirección no puede superar los 60 caracteres.");
    if (receptor.comuna.length > 20) errores.push("Comuna no puede superar los 20 caracteres.");
    if (receptor.ciudad.length > 20) errores.push("Ciudad no puede superar los 20 caracteres.");

    camposObligatorios.forEach(({ campo, etiqueta }) => {
      if (!receptor[campo] || receptor[campo].trim() === "") {
        errores.push(`El campo "${etiqueta}" es obligatorio.`);
      }
    });



    if (errores.length > 0) {
      setErroresReceptor(errores);
      setMostrarModalErrores(true);
      return false;
    }
    else {
      return true;
    }


  };


  const handleTranportesReceptor = async (receptor) => {
    // e.preventDefault();

    setShowModalTransportes(false);
    console.log('receptor id:', receptor.id);
    // return ;
    setLoading(true);
    setLoadingMensaje("Cargando transportes del receptor, por favor espere...");

    try {
      const resp = await api.getTransportesReceptor(receptor.id);
      console.log("Transportes del receptor:", resp.data.data.records);
      setTransportesReceptor(resp.data.data.records);

    } catch (error) {
      console.error("Error al obtener transportes del receptor:", error);
      setErrorApi("Error al obtener transportes del receptor: " + error.message);
      setMostrarModalErrorApi(true);
    }
    finally {
      setShowModalTransportes(true);
      setLoading(false);
    }


  }

  const handleDeleteTranportesReceptor = async () => {
    // e.preventDefault();

    setShowModalTransportes(true);
    console.log('receptor id:', receptorSeleccionado.id);
    console.log('patente a eliminar:', transporteAEliminar);
    // return;
    setLoading(true);

    try {
      // Eliminar transporte
      setLoadingMensaje("Actualizando transportes del receptor, por favor espere...");
      await api.deleteTransporte(receptorSeleccionado.id, transporteAEliminar);

      // Refrescar la lista de transportes
      const resp = await api.getTransportesReceptor(receptorSeleccionado.id);
      console.log("Transportes del receptor:", resp.data.data.records);

      setTransportesReceptor(resp.data.data.records);
      setMessageSuccess("Transporte eliminado exitosamente.");
      setSucessTitle("Eliminar Transporte Receptor");
      setShowSuccessModal(true);
      // setShowModalTransportes(false);
      setShowModalEliminarTransporte(false);

    } catch (error) {
      console.error("Error al obtener transportes del receptor:", error);
      setErrorApi("Error al obtener transportes del receptor: " + error.message);
      setMostrarModalErrorApi(true);
    }
    finally {
      setLoading(false);
    }


  }

  const handleGuardarTransporte = async (e) => {
    e.preventDefault();
    if (!receptorSeleccionado) return;

    const result = validarPatenteChile(nuevoTransporte.patente);

    if (!result.valid) {
      setPatenteError(result.error || "Patente no válida.");
      setPatenteValid(false);
      return;
    }

    setPatenteError("");
    setPatenteValid(true);

    setSavingTransporte(true);

    try {
      setLoadingMensaje("Guardando transporte del receptor, por favor espere...");
      setLoading(true);

      const params = {
        receptor_id: receptorSeleccionado.id,
        patente: result.normalized, 
        vehicle_type: nuevoTransporte.vehicle_type,
      };

      const resp = await api.addTransporte(params);

      const transporteCreado = resp.data.data.records[0] ?? {
        ...nuevoTransporte,
        patente: result.normalized,
      };

      setTransportesReceptor((prev) => [...prev, transporteCreado]);
      setNuevoTransporte({ patente: "", vehicle_type: "" });
      setShowModalAgregarTransporte(false);
    } catch (error) {
      console.error("Error al crear transporte:", error);
      setErrorApi("Error al crear transporte: " + error.message);
      setMostrarModalErrorApi(true);
    } finally {
      setLoading(false);
      setSavingTransporte(false);
    }
  };

  const handlePatenteChange = (e) => {
    // Siempre en mayúsculas
    let value = e.target.value.toUpperCase();

    value = value.replace(/[^A-Z0-9.\-\s]/g, "");

    setNuevoTransporte((prev) => ({
      ...prev,
      patente: value,
    }));

    // Si está vacío, no mostramos error todavía
    if (value.trim() === "") {
      setPatenteError("");
      setPatenteValid(false);
      return;
    }

    const result = validarPatenteChile(value);

    if (result.valid) {
      setPatenteError("");
      setPatenteValid(true);
    } else {
      setPatenteError(result.error || "Patente no válida.");
      setPatenteValid(false);
    }
  };


  const validarPatenteChile = (input) => {
    if (!input || typeof input !== "string") {
      return { valid: false, format: null, normalized: null, error: "Entrada vacía o no es string." };
    }

    // Normaliza: mayúsculas, sin espacios, guiones ni puntos
    const raw = input.toUpperCase().trim();
    const normalized = raw.replace(/[.\-\s]/g, "");

    // Set de letras permitido para formato nuevo (desde 2007)
    const NEW_SET = "BCDFGHJKLPRSTVWXYZ";
    // Set de letras permitido para formato antiguo (excluye I, Ñ, Q)
    const OLD_SET = "ABCDEFGHJKLMNOPRSTUVWXYZ";

    // Nuevo: 4 letras válidas + 2 números (10–99)
    const newRegex = new RegExp(`^[${NEW_SET}]{4}[1-9][0-9]$`);
    // Antiguo: 2 letras válidas + 4 números
    const oldRegex = new RegExp(`^[${OLD_SET}]{2}[0-9]{4}$`);

    // Verifica formato nuevo
    if (newRegex.test(normalized)) {
      return { valid: true, format: "new", normalized };
    }

    // Verifica formato antiguo
    if (oldRegex.test(normalized)) {
      return { valid: true, format: "old", normalized };
    }

    // Intenta generar errores más específicos
    if (/^[A-Z]{4}\d{2}$/.test(normalized)) {
      const letters = normalized.slice(0, 4);
      const num = Number(normalized.slice(4));
      if (num < 10) {
        return { valid: false, format: null, normalized: null, error: "En formato nuevo los números van de 10 a 99." };
      }
      const bad = letters.split("").some(ch => !NEW_SET.includes(ch));
      if (bad) {
        return { valid: false, format: null, normalized: null, error: "Formato nuevo: usa solo letras permitidas (B C D F G H J K L P R S T V W X Y Z)." };
      }
    }

    if (/^[A-Z]{2}\d{4}$/.test(normalized)) {
      const letters = normalized.slice(0, 2);
      const bad = letters.split("").some(ch => !OLD_SET.includes(ch));
      if (bad) {
        return { valid: false, format: null, normalized: null, error: "Formato antiguo: no se admiten I, Ñ ni Q." };
      }
    }

    return { valid: false, format: null, normalized: null, error: "Formato no válido para patente chilena." };
  }



  const handleRutBusquedaChange = (e) => {
    const input = e.target.value;

    // Eliminar caracteres no válidos (solo números y K/k)
    const limpio = input.replace(/[^0-9kK]/g, '');

    if (limpio === "") {
      setFiltros((prev) => ({
        ...prev,
        rut: "",
      }));
      setRutBusquedaError(""); // Limpia el error
      return;
    }

    try {
    
      setFiltros((prev) => ({
        ...prev,
        rut: limpio,
      }));

      // setRutBusquedaError(esValido ? "" : "RUT inválido");
    } catch (err) {
      setFiltros((prev) => ({
        ...prev,
        rut: limpio,
      }));
      // setRutBusquedaError("RUT inválido");
    }
  };






  return (
    <Container fluid>
      <h2 className="text-center my-4">Receptor Factura POS</h2>

      <Button variant="success" onClick={() => setShowModalAgregarReceptor(true)}>
        Agregar nuevo receptor
      </Button>

      <Card className="mb-4 shadow-sm">
        <Card.Header as="h5">Buscar Receptores</Card.Header>
        <Card.Body>
          <Form>
            <Row>
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Buscar por RUT</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Ej: 12.345.678-9"
                    value={filtros.rut}
                    onChange={handleRutBusquedaChange}
                    isInvalid={!!rutBusquedaError}
                  />
                  <Form.Control.Feedback type="invalid">
                    {rutBusquedaError}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>

              <Col md={3}>
                <Form.Group>
                  <Form.Label>Razón Social</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Ej: Receptor Ltda."
                    value={filtros.razon_social}
                    onChange={(e) => handleFiltroChange("razon_social", e.target.value)}
                  />
                </Form.Group>
              </Col>

              <Col md={3}>
                <Form.Group>
                  <Form.Label>Ciudad</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Ej: Santiago"
                    value={filtros.ciudad}
                    onChange={(e) => handleFiltroChange("ciudad", e.target.value)}
                  />
                </Form.Group>
              </Col>

              <Col md={3}>
                <Form.Group>
                  <Form.Label>Comuna</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Ej: Las Condes"
                    value={filtros.comuna}
                    onChange={(e) => handleFiltroChange("comuna", e.target.value)}
                    
                  />
                </Form.Group>
              </Col>
            </Row>

            <div className="mt-4 text-end">
              <Button variant="primary" onClick={() => buscarReceptores(1)} className="me-2">
                Buscar
              </Button>
              <Button variant="secondary" onClick={limpiarFiltros}>
                Limpiar
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>

      {busquedaRealizada && (
        <Card className="shadow-sm mt-3">
          <Card.Header as="h5">Resultados</Card.Header>
          <Card.Body>
            {receptores.length === 0 ? (
              <p>No se encontraron resultados.</p>
            ) : (
              <>
                <Table striped bordered hover responsive>
                  <thead>
                    <tr>
                      <th>RUT</th>
                      <th>Razón Social</th>
                      <th>Giro</th>
                      <th>Dirección</th>
                      <th>Comuna</th>
                      <th>Ciudad</th>
                      <th>Teléfono</th>
                      <th>Email</th>
                      <th>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {receptores.map((receptor, index) => (
                      <tr key={index}>
                        <td>{new Rut(receptor.rut + "", true).getNiceRut()}</td>
                        <td>{receptor.razon_social}</td>
                        <td>{receptor.giro}</td>
                        <td>{receptor.direccion}</td>
                        <td>{receptor.comuna}</td>
                        <td>{receptor.ciudad}</td>
                        <td>{formatearTelefonoChileno(receptor.telefono)}</td>
                        <td>{receptor.email}</td>
                        <td>
                          <Button
                            variant="primary"
                            size="sm"
                            className="me-2"
                            onClick={() => handleEditReceptor(receptor)}
                          >
                            <FaCog></FaCog>
                          </Button>

                          <Button
                            variant="danger"
                            size="sm"
                            className="me-2"
                            onClick={() => {
                              setReceptorSeleccionado(receptor);
                              setShowModalEliminar(true);
                            }}
                          >
                            <FaRegTrashAlt></FaRegTrashAlt>
                          </Button>

                          <Button
                            variant="info"
                            size="sm"
                            className="me-2"
                            onClick={() => {
                              setReceptorSeleccionado(receptor);
                              handleTranportesReceptor(receptor);
                            }}
                          >
                            <FaShuttleVan></FaShuttleVan>
                          </Button>

                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>

                <div className="d-flex justify-content-between align-items-center mt-3">
                  <span className="text-muted">
                    Total receptores: {totalResultados}
                  </span>
                  <div>
                    <Button
                      variant="primary"
                      size="sm"
                      className="me-2"
                      onClick={() => buscarReceptores(currentPage - 1)}
                      disabled={currentPage === 1}
                    >
                      Anterior
                    </Button>
                    <span>
                      Página {currentPage} de {totalPages}
                    </span>
                    <Button
                      variant="primary"
                      size="sm"
                      className="ms-2"
                      onClick={() => buscarReceptores(currentPage + 1)}
                      disabled={currentPage === totalPages}
                    >
                      Siguiente
                    </Button>
                  </div>
                </div>
              </>
            )}
          </Card.Body>
        </Card>
      )}

      {/* Modal agregarReceptor */}
      <ModalReceptorForm
        show={showModalAgregarReceptor}
        onHide={() => {
          setShowModalAgregarReceptor(false);
          handleLimpiarFormulario();

        }}
        titulo="Agregar Receptor"
        formData={formData}
        setFormData={setFormData}
        onConfirm={handleAgregarReceptor}
        // errores={{
        //   rut: rutReceptorError,
        //   telefono: telefonoError,
        //   email: emailError
        // }}
        opcionesActividad={opcionesActividad} 
        optionsRegion = {groupedRegionOptions}
      />


      {/* Modal Editar Receptor */}
      <ModalReceptorForm
        show={showModalEditar}
        onHide={() => {
          setShowModalEditar(false);
          handleLimpiarFormulario();
        }}
        titulo="Editar Receptor"
        formData={formData}
        setFormData={setFormData}
        onConfirm={handleEditarReceptor}
        // errores={{
        //   rut: rutReceptorError,
        //   telefono: telefonoError,
        //   email: emailError
        // }}
        opcionesActividad={opcionesActividad}
        optionsRegion = {groupedRegionOptions}
      />


      <Modal show={mostrarModalErrores} onHide={() => setMostrarModalErrores(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Errores en los datos del receptor</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ul>
            {erroresReceptor.map((error, index) => (
              <li key={index}>{error}</li>
            ))}
          </ul>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setMostrarModalErrores(false)}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>



      {/* Modal de Cargando */}
      <Modal show={loading} centered backdrop="static">
        <Modal.Body className="text-center">
          <div className="my-3">
            <span className="spinner-border text-primary" role="status" />
          </div>
          <p>{loadingMensaje}</p>
        </Modal.Body>
      </Modal>

      {/* Modal de Error */}
      <Modal show={mostrarModalErrorApi} onHide={() => setMostrarModalErrorApi(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Error</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{errorApi}</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setMostrarModalErrorApi(false)}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>


      {/* Modal de éxito */}
      <Modal show={showSuccessModal} onHide={handleCloseSuccessModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>{sucessTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {messageSuccess}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleCloseSuccessModal}>
            Aceptar
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal eliminar */}

      <Modal show={showModalEliminar} onHide={() => setShowModalEliminar(false)} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Confirmar Eliminación</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          ¿Estás seguro de que deseas eliminar al receptor <strong>{receptorSeleccionado?.razon_social}</strong>?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModalEliminar(false)}>
            Cancelar
          </Button>
          <Button variant="danger" onClick={handleEliminarReceptor}>
            Eliminar
          </Button>
        </Modal.Footer>
      </Modal>


      {/* Modal Transportes*/}

      <Modal
        show={showModalTransportes}
        onHide={() => setShowModalTransportes(false)}
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Transportes Receptor {receptorSeleccionado?.razon_social}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {loading ? (
            <p>Cargando transportes...</p>
          ) : (
            <>
              {/* Botón arriba de la tabla/mensaje */}
              <div className="d-flex justify-content-end mb-3">
                <Button
                  variant="primary"
                  size="sm"
                  onClick={() => setShowModalAgregarTransporte(true)}
                >
                  Agregar transporte
                </Button>
              </div>

              {transportesReceptor.length > 0 ? (
                <Table striped hover responsive className="mb-0">
                  <thead>
                    <tr>
                      <th style={{ width: 160 }}>Patente</th>
                      <th>Tipo vehículo</th>
                      <th>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {transportesReceptor.map((t, idx) => (
                      <tr key={t.patente ?? idx}>
                        <td>{t.patente ?? "—"}</td>
                        <td>{t.vehicle_type ?? "—"}</td>
                        <td>
                          <Button
                            variant="danger"
                            size="sm"
                            onClick={() => {
                              setTransporteAEliminar(t.patente);
                              setShowModalEliminarTransporte(true);
                            }}
                          >
                            <FaRegTrashAlt />
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              ) : (
                <div className="text-center text-muted py-3">
                  No hay transportes registrados para este receptor.
                </div>
              )}
            </>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModalTransportes(false)}>
            Cancelar
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Modal eliminar Transporte*/}

      <Modal show={showModalEliminarTransporte} onHide={() => setShowModalEliminarTransporte(false)} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Confirmar Eliminación</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          ¿Estás seguro de que deseas eliminar transporte patente <strong> {transporteAEliminar}</strong> del receptor <strong>{receptorSeleccionado?.razon_social}</strong>?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModalEliminarTransporte(false)}>
            Cancelar
          </Button>
          <Button variant="danger" onClick={handleDeleteTranportesReceptor}>
            Eliminar
          </Button>
        </Modal.Footer>
      </Modal>


      {/* Modal agregar transporte */}

      <Modal
        show={showModalAgregarTransporte}
        onHide={() => setShowModalAgregarTransporte(false)}
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>Agregar transporte</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <form onSubmit={handleGuardarTransporte}>
            <div className="mb-3">
              <label className="form-label">Patente</label>
              <input
                type="text"
                className={`form-control ${patenteError ? "is-invalid" : patenteValid ? "is-valid" : ""}`}
                value={nuevoTransporte.patente}
                onChange={handlePatenteChange}
                required
              />
              {patenteError && (
                <div className="invalid-feedback">
                  {patenteError}
                </div>
              )}
            </div>

            <div className="mb-3">
              <label className="form-label">Tipo de vehículo</label>
              <input
                type="text"
                className="form-control"
                value={nuevoTransporte.vehicle_type}
                onChange={(e) =>
                  setNuevoTransporte((prev) => ({
                    ...prev,
                    vehicle_type: e.target.value,
                  }))
                }
                required
              />

            </div>


            <div className="d-flex justify-content-end">
              <Button
                type="submit"
                variant="primary"
                disabled={savingTransporte || !patenteValid}
              >
                {savingTransporte ? "Guardando..." : "Guardar"}
              </Button>
            </div>
          </form>
        </Modal.Body>
      </Modal>





    </Container >
  );
}

export default ReceptorFactura;
